import { getCommonQuickNavPages } from "constants/quickNav/common";
import { APPS_QUICK_NAV_PAGES } from "constants/quickNav/apps";
import { SETTINGS_QUICK_NAV_PAGES } from "constants/quickNav/settings";
import { QuickNavPage } from "constants/quickNav/types";

const MAILROOM_HOME_PATH = "/mailroom";

export const MAILROOM_QUICK_NAV_PAGES: QuickNavPage[] = [
  { name: "Home", path: MAILROOM_HOME_PATH },
  { name: "Inbox", path: "/mailroom/inbox" },
  { name: "Registered Agent", path: "/mailroom/registered-agent" },
  ...getCommonQuickNavPages(MAILROOM_HOME_PATH),
  ...SETTINGS_QUICK_NAV_PAGES,
  ...APPS_QUICK_NAV_PAGES.filter(({ path }) => path !== MAILROOM_HOME_PATH),
];
